import React, { FC } from 'react';

import styles from './Tab.module.css';

type Props = {
  selected?: boolean;
  onClick?: () => void;
};

const Tab: FC<Props> = ({ children, selected, onClick }) => (
  <div
    className={`${styles.tab} ${selected && styles.selected}`}
    onClick={onClick}>
    {children}
  </div>
);

export default Tab;
